import { button, el } from "./dom.js";

export class MobileNotice {
  constructor(parent: HTMLElement) {
    const coarse = window.matchMedia("(pointer: coarse)").matches;
    const fine = window.matchMedia("(any-pointer: fine)").matches;
    if (!coarse || fine) return;

    const overlay = el("div", "overlay");
    const panel = el("div", "panel mobile-notice");
    panel.appendChild(el("h2", undefined, "Desktop only (for now)"));
    panel.appendChild(
      el(
        "p",
        undefined,
        "The Agency plays best with a keyboard. Touch controls are coming later — you can still look around.",
      ),
    );
    const continueBtn = button("Continue anyway", "btn-primary");
    continueBtn.addEventListener("click", () => overlay.remove());
    panel.appendChild(continueBtn);
    overlay.appendChild(panel);
    parent.appendChild(overlay);
  }
}
